import * as AxiosFunctions from '../functions/AxiosFunctions';
import { ENV_CONFIG } from '../../commons/Constants/Constants';

// Función para obtener el token almacenado o solicitar uno nuevo si no existe
const getTokenMw = async () => {
    let responseToken;
    const headersToken = {
        headers:{
            'api-key': ENV_CONFIG.KEY_MIDDLEWARE_URL,
            'Access-Control-Allow-Origin': '*',
        }
    }
    const params ={
        'id': "",
    }
    try {
        responseToken = await AxiosFunctions.postMethod(
          ENV_CONFIG.MF_EXAMENS_URL+"/auth/token",
          params,
          headersToken,
        ) 
        return responseToken
    } catch (error) {
        return error
    }
};

// Función para obtener el tipo de documento
const getDocumentType = async (typeOfSearch: string, tokenMw: string) => {
  let responseDocumentType;
  const headersDocumentType = {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Authorization': `Bearer ${tokenMw}`,
    },
  };

  try {
    // Agregamos el parámetro de path variable a la URL
    const url = `${ENV_CONFIG.MF_EXAMENS_URL}/exams/sample-types/${typeOfSearch}`;

    responseDocumentType = await AxiosFunctions.getMethod(
      url,
      headersDocumentType
    );

    return responseDocumentType;
  } catch (error) {
    return error
  }
}

const getSampleName = async (typeOfSearch: string, tokenMw: string) => {
  let responseDocumentType;
  const headersDocumentType = {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Authorization': `Bearer ${tokenMw}`,
    },
  };

  try {
    // Agregamos el parámetro de path variable a la URL
    const url = `${ENV_CONFIG.MF_EXAMENS_URL}/exams/test-names/${typeOfSearch}`;

    responseDocumentType = await AxiosFunctions.getMethod(
      url,
      headersDocumentType
    );

    return responseDocumentType;
  } catch (error) {
    return error
  }
}

const getCupsCode = async (typeOfSearch: string, tokenMw: string) => {
  let responseDocumentType;
  const headersDocumentType = {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Authorization': `Bearer ${tokenMw}`,
    },
  };

  try {
    // Agregamos el parámetro de path variable a la URL
    const url = `${ENV_CONFIG.MF_EXAMENS_URL}/exams/code-cups/${typeOfSearch}`;

    responseDocumentType = await AxiosFunctions.getMethod(
      url,
      headersDocumentType
    );

    return responseDocumentType;
  } catch (error) {
    return error
  }
}

const getCodeLaboratory = async (tokenMw: string) => {
  let responseDocumentType;
  const headersDocumentType = {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Authorization': `Bearer ${tokenMw}`,
    },
  };

  try {
    // Agregamos el parámetro de path variable a la URL
    const url = `${ENV_CONFIG.MF_EXAMENS_URL}/exams/laboratory-codes/company`;

    responseDocumentType = await AxiosFunctions.getMethod(
      url,
      headersDocumentType
    );

    return responseDocumentType;
  } catch (error) {
    return error
  }
}

//Función para obtener los titulos
const getTitles = async (liferayid: string, tokenMw: string) => {
  let responseTitles;
  const headersTitles = {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Authorization': `Bearer ${tokenMw}`,
    },
  };
  try {

    const url = `${ENV_CONFIG.MF_EXAMENS_URL}/exams/titles/${liferayid}`

    responseTitles = await AxiosFunctions.getMethod(
      url,
      headersTitles
    );
    return responseTitles
  } catch (error) {
    return error
  }
}

// Función para enviar los datos del usuario
const postDataUser = async (typeOfSearch: string, tokenMw: string, cupsCode?: string, laboratoryCode?: string, sampleType?: string, testName?: string) => {
  try {
    const params = JSON.stringify({
      "typeOfSearch": typeOfSearch,
      ...(cupsCode && { cupsCode }),           
      ...(laboratoryCode && { laboratoryCode }), 
      ...(sampleType && { sampleType }),        
      ...(testName && { testName })
    });

    const response = await AxiosFunctions.postMethod(
      ENV_CONFIG.MF_EXAMENS_URL+"/exams",
      params,
      {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${tokenMw}`,
          },
      }
    );

    return response;
  } catch (error) {
    console.error("Error al realizar la solicitud a la API:", error);
    throw error;
  }
};

export {
  postDataUser,
  getTokenMw,
  getDocumentType,
  getTitles,
  getSampleName,
  getCupsCode,
  getCodeLaboratory
};
